import {useAuth} from './authContext';
import {useGuest} from './GuestContext';
export function useBadgeScope(){
 const {user,privileges}=useAuth(),{farm}=useGuest();
 return JSON.stringify([farm?.farm_id,user?.email,user?.status,user?.roles,user?.role,user?.farm_ids,privileges]);
}
